<template>
  <transition v-if="canRender" name="fade-up-in" appear>
    <div v-if="shouldShow" class="pwa-prompt" :class="[{ shown: shouldShow }]">
      <span class="pwa-prompt__text">برای دسترسی سریع‌تر، اپلیکیشن را به صفحه اصلی نصب کنید</span>

      <button type="button" class="install-button" @click.stop="installPWA">
        نصب
      </button>

      <button
        type="button"
        class="close-button"
        aria-label="بستن بدون نصب"
        @click.stop.prevent="dismissPrompt"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </transition>
</template>

<script>
const PWA_BLOCKED_ROUTE_NAMES = ["HampaPay", "Register", "v"];
const PWA_DISMISS_STORAGE_KEY = "netpa-pwa-prompt-dismissed";

function isNetPaAuthenticated(session) {
  return !!(
    session.get("TokenNetPa") &&
    session.get("CustCode") &&
    session.get("AccessMenu")
  );
}

function isNetPaAuthRoute(route) {
  return !!(route && route.path && route.path.startsWith("/PishkhanNetPa/"));
}

export default {
  data: () => ({
    installEvent: undefined,
    shown: false,
  }),

  computed: {
    canRender() {
      return !PWA_BLOCKED_ROUTE_NAMES.includes(this.$route.name);
    },
    isAuthenticatedNetPa() {
      return isNetPaAuthenticated(this.$session);
    },
    isOnAuthRequiredPage() {
      return isNetPaAuthRoute(this.$route);
    },
    shouldShow() {
      if (!this.shown) return false;
      if (this.isDismissedInSession()) return false;
      if (this.isAuthenticatedNetPa && this.isOnAuthRequiredPage) return false;
      return true;
    },
  },

  watch: {
    $route() {
      this.hideOnAuthContext();
    },
    isAuthenticatedNetPa() {
      this.hideOnAuthContext();
    },
  },

  mounted() {
    if (this.isDismissedInSession()) {
      this.shown = false;
    }
    this.hideOnAuthContext();
  },

  beforeMount() {
    if (!this.canRender) return;
    if (this.isAuthenticatedNetPa && this.isOnAuthRequiredPage) return;
    window.addEventListener("beforeinstallprompt", this.onBeforeInstallPrompt);
  },

  beforeDestroy() {
    window.removeEventListener("beforeinstallprompt", this.onBeforeInstallPrompt);
  },

  methods: {
    isDismissedInSession() {
      try {
        return sessionStorage.getItem(PWA_DISMISS_STORAGE_KEY) === "1";
      } catch (error) {
        return false;
      }
    },

    persistDismissal() {
      try {
        sessionStorage.setItem(PWA_DISMISS_STORAGE_KEY, "1");
      } catch (error) {
        // ignore quota / private mode
      }
    },

    onBeforeInstallPrompt(e) {
      if (this.isDismissedInSession()) return;
      if (isNetPaAuthenticated(this.$session) && isNetPaAuthRoute(this.$route)) {
        return;
      }
      e.preventDefault();
      this.installEvent = e;
      this.shown = true;
    },

    hideOnAuthContext() {
      if (this.isAuthenticatedNetPa && this.isOnAuthRequiredPage) {
        this.shown = false;
      }
    },

    installPWA() {
      if (!this.installEvent) return;
      this.installEvent.prompt();
      this.installEvent.userChoice.then(() => {
        this.dismissPrompt();
      });
    },

    dismissPrompt() {
      this.shown = false;
      this.persistDismissal();
    },
  },
};
</script>

<style lang="scss">
:root {
  --background: #e0fbfc;
  --bright: #ee6c4d;
  --dark: #3d5a80;
  --darker: #293241;
  --accent: #98c1d9;
}

.pwa-prompt {
  direction: rtl;
  position: fixed;
  font-size: 1rem;
  z-index: 1060;
  line-height: 1.4;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 1rem 3.25rem 1rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 4rem;
  background: var(--dark);
  color: var(--background);
  transform: translateY(0);
  margin: 0;
  pointer-events: auto;
  box-sizing: border-box;

  .pwa-prompt__text {
    text-align: center;
  }

  .install-button {
    font-size: 0.95rem;
    flex-shrink: 0;
    margin: 0;
    padding: 0.65em 1.25em;
    background-color: var(--bright);
    border: 0;
    border-radius: 4px;
    line-height: 1;
    font-weight: 600;
  }

  .close-button {
    position: absolute;
    inset-inline-end: 0;
    inset-inline-start: auto;
    top: 0;
    bottom: 0;
    font-size: 2rem;
    background: transparent;
    border: 0;
    padding: 0 0.85rem;
    min-width: 2.75rem;
    height: auto;
    line-height: 1;
    color: inherit;
    cursor: pointer;
    z-index: 2;
    pointer-events: auto;
  }

  .sr {
    position: absolute;
    width: 1px;
    height: 1px;
    left: -9999px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
}

.fade-up-in-enter-active,
.fade-up-in-leave-active {
  transition: opacity 1s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 1s cubic-bezier(0.165, 0.84, 0.44, 1);
  transform: translateY(0);
}

.fade-up-in-enter,
.fade-up-in-leave-to {
  opacity: 0;
  transform: translateY(4rem);
}
</style>
